import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatOption, MatSelect } from '@angular/material/select';

@Component({
    selector: 'app-time-field',
    imports: [
        MatFormField,
        MatLabel,
        MatSelect,
        ReactiveFormsModule,
        MatOption
    ],
    templateUrl: './time-field.component.html',
    styleUrl: './time-field.component.scss'
})
export class TimeFieldComponent {

    @Input()
    public control: FormControl;

    @Input()
    public caption: string;

    @Output()
    public change: EventEmitter<void> = new EventEmitter<void>();

    times(): string[] {
        const times = [];
        for (let i = 7; i <= 19; i++) {
            const hour = i < 10 ? '0' + i : i;
            times.push(hour + ':00');
            times.push(hour + ':30');
        }
        return times;
    }

    public valueChanged(): void {
        this.change.emit();
    }

}
